module.exports = __webpack_public_path__ + "img/ico-upload-photo.81de665d.svg";